<section id="front_wrap">
  <section id="front_page" class="profile_step">
    <section id="menu_front">
    <span class="badge badge-danger" *ngIf="takeInHand && takeInHand === 'yes'">
        <h6 style="color: #ffffff;font-size: 12px;">
        <span class="bx bx-info-circle"></span> {{'messages.accountControlActive' | translate}} <br>{{'messages.ofThisAccount' | translate}}
       </h6>
         <button type="button" class="btn btn-primary waves-effect waves-light" (click)="returner(admin_login)">
            {{'header.returnPreviousAccount' | translate}}
          </button>
      </span>
      <a class="menu_item menu_search" href="dashboard/inspector"><img src="assets/img/icon_search.png"> <p>{{'inspector.search' | translate}}</p></a>
      <a class="menu_item menu_profile current" href="dashboard/inspector/profile"><img src="assets/img/icon_profile.png"> <p>{{'fields.profile' | translate}}</p></a>
      <a class="menu_item menu_export" href="dashboard/inspector/inspector-export"><img src="assets/img/icon_profile.png"> <p>{{'common.export' | translate}}</p></a>
      <a (click)="logout_user()" class="menu_item menu_logout" ><img src="assets/img/icon_logout.png"> <p>{{'header.logout' | translate}}</p></a>
    </section>
    <section id="big_front">
      <div id="name_connected">
        <p>{{single_user.name}}</p>
        <img src="{{single_user.photo}}">
      </div>
      <div id="content_front">
        <p class="h1">{{'pages.myProfile' | translate}}</p>
        <form>
          <div class="row">
            <div class="col-sm-12">
              <img src="{{previewUrl? previewUrl : this.single_user.photo}}" class="rounded-circle" height="100">
            </div> 
          </div>
          <input type="text"  [placeholder]="'fields.firstName' | translate"  value="{{single_user.firstname}}" [(ngModel)]="single_user.firstname" [ngModelOptions]="{standalone: true}">
          <input type="text"  [placeholder]="'fields.lastName' | translate"  value="{{single_user.name}}" [(ngModel)]="single_user.name" [ngModelOptions]="{standalone: true}">
          <input type="email"  [placeholder]="'fields.email' | translate" value="{{single_user.email}}" [(ngModel)]="single_user.email" [ngModelOptions]="{standalone: true}">
          <input type="password" [placeholder]="'fields.password' | translate"  value="" [(ngModel)]="single_user.password" [ngModelOptions]="{standalone: true}">
          <input type="password" [placeholder]="'auth.confirmPassword' | translate"  value="" [(ngModel)]="single_user.password_confirm" [ngModelOptions]="{standalone: true}">
          <br><i>{{'messages.leavePasswordEmpty' | translate}}</i>
          <div class="alert alert-success text-center" role="alert" *ngIf="success_Message">
            {{text}}
            <button type="button" class="close" data-dismiss="alert" [attr.aria-label]="'common.close' | translate">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="alert alert-danger text-center" role="alert" *ngIf="not_success_Message">
            {{text}}
            <button type="button" class="close" data-dismiss="alert" [attr.aria-label]="'common.close' | translate">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <button class="blue_btn" (click)="update_profile()">{{'common.validate' | translate}}</button>
        </form>
      </div>
      <div id="bottom_logo">
        <img src="assets/img/logo-alaya.png">
      </div>
    </section>
  </section>
  <div id="front_legal">
    <p>CERTIKAP - par <strong>Kaptitude</strong> - 2020</p>
  </div>
</section>
